<template>
  <div>
      <div class="sticky-top_">
          <div class="control-panel mb-2 shadow-sm" id="#controlPanel" :style="panelStyle" @mouseover="Front(true)" @mouseleave="Front(false)">
              <div class="header py-1">
                  <div class="container-fluid">
                      <div class="row">
                          <div class="col-12 col-md-5">
                              <h1><span v-if="typeof icon !== 'undefined'" :class="icon"></span> {{ title }}</h1>
                          </div>
                          <div class="col-12 col-md-2 text-center">
                              <b-link v-if="$route.path != '/'" to="/" class="btn btn-sm btn-danger"><span class="mdi mdi-calculator"></span> Перейти в калькулятор</b-link>

                          </div>
                          <div class="col-12 col-md-5 text-right">
                              <div v-if="user.registered && !user.subscribe_expired"><span class="mdi mdi-wallet"></span>&nbsp;
                                  Ваша подписка действительна до {{ user.subscribe }}
                              </div>

                              <div v-if="user.registered && user.subscribe_expired"><span class="mdi mdi-wallet"></span>&nbsp;
                                  Ваша подписка просрочена <b-link class="btn btn-sm btn-success" to="/info/price/"><span class="mdi mdi-credit-card"></span> Приобрести подписку</b-link>
                              </div>

                              <div v-if="!user.registered"><span class="mdi mdi-login"></span>&nbsp;
                                  Для отображения данных о подписке авторизируйтесь на сайте
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="d-none d-md-block fast-links py-1" v-if="typeof links !== 'undefined' && links.length > 0" style="font-size: .8rem">
                  <div class="container-fluid">
                      <div class="row">
                          <div class="col-12">
                              <div class="float-left title"><span class="mdi mdi-link"></span> Быстрый переход:</div>
                              <b-nav>
                                  <template v-for="(item, index) in links">
                                      <b-nav-item :key="index" :to="item.link"><span v-if="typeof item.icon !== 'undefined' && item.icon != ''" :class="item.icon"></span> {{item.name}}</b-nav-item>
                                  </template>

                              </b-nav>

                          </div>

                      </div>
                  </div>
              </div>
              <div class="">
                  <div class="controls py-1" v-if="$slots.default || $slots.left">
                      <div class="container-fluid">
                          <div class="row">
                              <div class="col-12">
                                  <div class="w-100">
                                      <div class="form-inline float-left">
                                          <slot name="left"></slot>
                                      </div>
                                      <div class="form-inline float-right">
                                          <slot></slot>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>

          </div>
      </div>

  </div>

</template>


<script>
import {mapGetters} from "vuex";

export default {
  name: 'ControlPanel',
  props: {
    icon: {
      type: String,
      default: 'mdi mdi-file'
    },
    title: {
      type: String,
      default: ''
    },
    links: {
      type: Array
    },
    premium: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      panelStyle: 'z-index: 500'
    }
  },
  methods: {
    Front(mode) {
      switch (mode) {
        case true:
          this.panelStyle = 'z-index: 510'
          break;
          case false:
            this.panelStyle = 'z-index: 500'
            break;
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'user'
    })
  }
}
</script>


<style>
.gradient-l-r {
  background: linear-gradient(to right, #E0E0E0, rgba(255, 255, 255, 0));
}

.gradient-r-l {
  background: linear-gradient(to left, #E0E0E0, rgba(255, 255, 255, 0));
}
</style>
